// extracted by mini-css-extract-plugin
module.exports = {"faqSearchForm":"FaqSearchForm_faqSearchForm__eg1cD","inputWrap":"FaqSearchForm_inputWrap__x3Sqa","input":"FaqSearchForm_input__axTPZ","submit":"FaqSearchForm_submit__qD811"};